import React, { useCallback, useEffect, useRef, useState } from 'react';

import * as BABYLON from "@babylonjs/core";
import '@babylonjs/loaders'
import * as cannon from "cannon";


const DEFAULT_CONTEXT = {
  scene: null,
  canvasRef: () => {},
  engineRef: () => {},
  createScene: () => {},
  islandLoaded: false,
};


const setupScene = async (scene) => {
  if (false) {
    scene.enablePhysics(new BABYLON.Vector3(0, -9.81, 0), new BABYLON.CannonJSPlugin(true, 10, cannon));
  } else {
    let p = window.Ammo();
    p.then(() => {
      scene.enablePhysics(new BABYLON.Vector3(0, -9.81, 0), new BABYLON.AmmoJSPlugin());
    })
  }

  let light = new BABYLON.HemisphericLight("light1", new BABYLON.Vector3(0, 20, 0), scene);
  light.intensity = 1.4;

  let ground = BABYLON.Mesh.CreateGround("ground1", 50000, 50000, 2, scene);
  ground.position.y = 0;
  window.ground = ground
  ground.visibility = 0.1;
  ground.physicsImpostor = new BABYLON.PhysicsImpostor(ground, BABYLON.PhysicsImpostor.BoxImpostor, { mass: 0, restitution: 0.0, friction:100 }, scene);

  scene.getEngine().runRenderLoop(function () { // Register a render loop to repeatedly render the scene
    scene.render();
  });


  window.addEventListener("resize", function () { // Watch for browser/canvas resize events
    scene.getEngine().resize();
  });
};

const SceneContext = React.createContext(DEFAULT_CONTEXT);

const SceneProvider = ({ children }) => {
  const [ context, setContext ] = useState(DEFAULT_CONTEXT);
  const [ islandLoaded, setIslandLoaded ] = useState(false);
  const engineRef = useRef();
  const cameraRef = useRef();
  const sceneRef = useRef();

  const setCanvas = useCallback((canvas) => {
    setContext((ctx) => {
      return {...ctx, canvas}
    });
    engineRef.current = new BABYLON.Engine(canvas, false);
    sceneRef.current = new BABYLON.Scene(engineRef.current);

    let camera = cameraRef.current = new BABYLON.ArcRotateCamera("sodabitCamera1", -1.57, .6, 20, new BABYLON.Vector3(0,20,0), sceneRef.current );
    camera.attachControl(canvas, false);
    //sodabitCamera.rotationOffset = 1.57;
    //sodabitCamera.rotationOffset = 3.14;
    camera.collisionRadius = new BABYLON.Vector3(0.5, 0.5, 0.5);
    camera.heightOffset = 10;
    camera.cameraAcceleration = 0.02;
    camera.maxCameraSpeed = 10;
    camera.lowerRadiusLimit = 10;
    camera.upperRadiusLimit = 100;

    window.camera = camera;

    setupScene(sceneRef.current);
  }, []);

  useEffect(() => {
    setContext((ctx) => {
      return {
        ...ctx,
        engineRef,
        sceneRef,
        cameraRef,
        canvasRef: setCanvas,
        islandLoaded,
        setIslandLoaded,
      };
    });
  }, [setCanvas, setIslandLoaded, islandLoaded ]);

  return (
    <SceneContext.Provider value={context}>
      { children }
    </SceneContext.Provider>
  );
};


export {
  SceneContext,
  SceneProvider,
};
